if (!customElements.get('leslis-gift-wrap')) {
  customElements.define('leslis-gift-wrap', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-preview')) return;
      this.product = this.closest('product-info');
      this.refreshPersonalisation = () => {
        const enabled = this.product?.querySelector('[id^="Recipient-checkbox-"]')?.checked;
        for (const [field, selector] of [['name', '[data-gift-recipient]'], ['message', '[data-gift-message]']]) {
          const value = enabled ? this.product?.querySelector(`[id^="Recipient-${field}-"]`)?.value.trim() : '';
          const target = this.querySelector(selector);
          target.textContent = value || '';
          target.hidden = !value;
        }
      };
      this.product?.addEventListener('input', this.refreshPersonalisation);
      this.product?.addEventListener('change', this.refreshPersonalisation);
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.sectionId) return;
          const amount = data.html.querySelector('[data-gift-amount]');
          if (amount) this.querySelector('[data-gift-amount]').textContent = amount.textContent;
        });
      }
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.product?.removeEventListener('input', this.refreshPersonalisation);
      this.product?.removeEventListener('change', this.refreshPersonalisation);
    }
  });
}
